import { type ButtonHTMLAttributes, forwardRef } from 'react';

interface ChipProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  selected?: boolean;
}

export const Chip = forwardRef<HTMLButtonElement, ChipProps>(
  ({ selected = false, className = '', children, ...props }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        aria-pressed={selected}
        className={[
          'inline-flex items-center rounded-chip px-3 py-1.5 text-sm font-medium',
          'transition-colors duration-80 ease-out',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20',
          selected
            ? 'bg-primary text-primary-foreground'
            : 'border border-border bg-card text-foreground hover:bg-background',
          className,
        ].join(' ')}
        {...props}
      >
        {children}
      </button>
    );
  },
);

Chip.displayName = 'Chip';
